import { trim, utils, hashQuery, query } from '@didi/webx-js-core';
let regs = {
    'android': /android/i,
    'iphone': /iphone/i,
    'ipad': /ipad/i,
    'ipod': /ipod/i,
    'rPassenger': /com.sdu.didi.psnger/i,
    'weixin': /micromessenger/i,
    'mqq': /QQ\//i,
    'alipay': /alipayclient/i,
    'douyin': /ToutiaoMicroApp/i,
    'miniprogram': /miniprogram|ToutiaoMicroApp/i,
    'passenger': /didi.passenger/i,
    'driverAndroid': /didigsui/i,
    'driverIOS': /ddudriver/i,
    'fusion': /fusionkit/i,
    'kfpassenger': /kflower\.passenger/i,
    'kfdriver': /kflower(\.|u)driver/i,
    'esapp': /didies/i,
    'hitchapp': /blord/i,
    'hydriver': /freight.driver/i,
    'hkdriver': /_didigsui_driverhk/i
};
/**
 * 处理userAgent
*/
export function parseUserAgent(userAgent) {
    let ret = {}, ua = userAgent;
    for (let key in regs) {
        ret[key] = regs[key].test(ua);
    }
    ret.ios = ret.iphone || ret.ipad || ret.ipod;
    ret.driver = ret.driverAndroid || ret.driverIOS;
    ret.native = ret.passenger || ret.rPassenger || ret.kfdriver || ret.kfpassenger || ret.driver || ret.hydriver;
    return ret;
}
/**
 * 检测当前环境,用于直接检测当前环境是否符合对应字符串。
 * @param strs 所需要判断的环境str。可判断的环境取值参考文档，"."代表并，","代表或
 * @returns boolean
 * @example
 * ```js
 *  is('passenger') // 乘客端
 *  is('passenger,kfpassenger') // 滴滴乘客端或花小猪客户端
 *  is('passenger.ios') // 滴滴乘客端且ios系统
 * ```
 */
export function is(strs, userAgent) {
    let str = strs.split(',');
    let ua = parseUserAgent(userAgent);
    let check = function (rote) {
        rote = trim(rote) || '';
        if (!rote) {
            return false;
        }
        let rotes = rote.split('.');
        let ret = true;
        utils.each(rotes, function (r) {
            if (!ua[r]) {
                ret = false;
                return false;
            }
        });
        return ret;
    };
    let ret = false;
    utils.each(str, function (s) {
        if (check(s)) {
            ret = true;
            return false;
        }
    });
    return ret;
}
// 微信小程序appid & xenv
const MP_XENV_MAP = {
    'wxaf35009675aa0b2a': 'wxmp',
    'wx9e9b87595c41dbb7': 'qjwxmp',
    'wxebb11cb254ce8575': 'yxwxmp',
    'wxab1642da834a1339': 'hywxmp',
    'wxdda4c7baff6748d1': 'sfcwxmp',
    'wxd7fa7df243b05aed': 'cxwxmp',
    'wx5d32d893dc4d0064': 'thwxmp',
    'wxd98a20e429ce834b': 'kfwxmp',
    'wx0d252f6ed9755862': 'gaswxmp',
    'ttc4c2b27f5bfd0d8701': 'dymp',
    'wx45eab49ff49af53f': 'eshwxmp', // 滴滴企业版助手小程序
};
/**
 * key 为xenv
 * value 端类型
 * 若有新加类型【注意顺序】，ua中有冲突的情况，例如顺风车中也有didi.passenger，可能会被匹配为passenger
 */
const XENV_BY_ISUA = {
    'hitchapp': 'hitchapp',
    'passenger': 'passenger',
    'driver': 'driver',
    'kfpassenger': 'kfpassenger',
    'kfdriver': 'kfdriver',
    'esapp': 'esapp',
    'hydriver': 'hydriver',
    'weixin': 'weixin',
    'alipay': 'alipay',
    'mqq': 'mqq',
    'hkdriver': 'hkdriver'
};
function matchAppId(userAgent) {
    if (!userAgent)
        return '';
    const appid = userAgent.match(/miniprogram\/(\S*)/i);
    return appid ? appid[1] : '';
}
export function xenv(options) {
    const { url, userAgent } = options;
    let Query = Object.assign({}, query(url), hashQuery(url));
    // 小程序
    if (is('miniprogram', userAgent)) {
        const appId = matchAppId(userAgent);
        if (appId && MP_XENV_MAP[appId]) {
            if (MP_XENV_MAP[appId] !== Query.xenv) {
                // 直接使用trackEvent会导致重复引用问题
                // todo 优化webxjs内部埋点
                globalThis?.Omega?.trackEvent?.('pub_webx_jssdk_error_bt', 'webx_jsssdk异常', {
                    type: 'error',
                    api: 'xenv',
                    prod_key: Query.prod_key,
                    dchn: Query.dchn,
                    extra: {
                        uaAppid: MP_XENV_MAP[appId],
                    }
                });
            }
            return MP_XENV_MAP[appId];
        }
        if (Query.xenv && Query.xenv !== 'h5') {
            return Query.xenv;
        }
        globalThis?.Omega?.trackEvent?.('pub_webx_jssdk_error_bt', 'webx_jsssdk异常', {
            type: 'error',
            api: 'xenv',
            prod_key: Query.prod_key,
            dchn: Query.dchn,
        });
        if (is('weixin', userAgent)) {
            return 'wxmp';
        }
        if (is('alipay', userAgent)) {
            return 'alimp';
        }
        if (is('mqq', userAgent)) {
            return 'qqmp';
        }
        if (is('douyin', userAgent)) {
            return 'dymp';
        }
    }
    // 其他
    let defaultXenv = Object.keys(XENV_BY_ISUA).find(xenvKey => {
        if (is(XENV_BY_ISUA[xenvKey], userAgent)) {
            return xenvKey;
        }
    });
    if (defaultXenv) {
        return defaultXenv;
    }
    return 'h5';
}
export const ua = parseUserAgent();
